import DataEntry from "./DataEntry";

export default DataEntry;